var module = angular.module('octopusApp.projects');


module.controller('StepTemplatesController', function ($scope, busy, $stateParams, $location, pageTitle, projectState,
                                                       octopusRepository, octopusPermissionSet, pluginRegistry, $filter, actionTemplateProcessor) {
    var isLoading = $scope.isLoading = busy.create();
    var isInstalling = $scope.isInstalling = busy.create();
    var projectId = $stateParams.projectId;

    var parentStepId = $stateParams["parentStepId"];
    var isNormalStep = !parentStepId;

    var getNewStepUrl = function(actionTemplate) {
        var url = "";

        if (isNormalStep) {
            url = "/projects/" + $scope.project.Slug + "/process/step/new/" + actionTemplate.ActionType;
        }
        else {
            // Add 'child' step
            url = "/projects/" + $scope.project.Slug + "/process/step/" + parentStepId + "/new/" + actionTemplate.ActionType;
        }

        if (actionTemplate.Id) {
            url = url + "/" + actionTemplate.Id;
        }

        return url;
    };

    $scope.resolveLink = $filter('resolveLink');
    $scope.add = function (type, id) {
        var tmpActionTemplate = {Id: id, ActionType: type};
        var url = getNewStepUrl(tmpActionTemplate);
        $location.path(url);
    };

    $scope.redirectToLibraryStepDetails = function (id) {
        $location.path("/library/steptemplates/community/" + id + "/details").search("from", projectId);
    };

    $scope.install = function (id) {
        return isLoading.promise(octopusRepository.CommunityActionTemplates.get(id).then(function (template) {
            return actionTemplateProcessor.installCommunityActionTemplate(template, getNewStepUrl, false, isInstalling);
        }));
    };

    $scope.update = function (id) {
        $scope.redirectToLibraryStepDetails(id);
    };

    $scope.details = function (id) {
        $scope.redirectToLibraryStepDetails(id);
    };

    $scope.allTemplates = [];
    $scope.filteredInstalledTemplates = [];
    $scope.filteredLibraryTemplates = [];

    $scope.enableGrouping = true;

    $scope.actionsToShow = _.chain(pluginRegistry.getAllActions())
                                .filter(function(action) {
                                   return !action.canShow || action.canShow();
                                });

    $scope.actionTypesToShow = $scope.actionsToShow.map(function(action){return action.actionType;}).value();
    $scope.childActionTypesToShow = $scope.actionsToShow.filter(function (action) { return action.canBeChild; }).map(function(action){return action.actionType;}).value();

    $scope.filterTemplates = function () {
        $scope.enableGrouping = !(!!this.inputText);

        if (isNormalStep) {
            $scope.filteredInstalledTemplates = actionTemplateProcessor.filterActionTemplates($scope.allTemplates, this.inputText, function (template) {
                return template.IsInstalled && _.contains($scope.actionTypesToShow, template.Type);
            });
        } else {
            $scope.filteredInstalledTemplates = actionTemplateProcessor.filterActionTemplates($scope.allTemplates, this.inputText, function (template) {
                return template.IsInstalled && _.contains($scope.childActionTypesToShow , template.Type);
            });
        }

        $scope.filteredLibraryTemplates = actionTemplateProcessor.filterActionTemplates($scope.allTemplates, this.inputText, function (template) { return !template.IsInstalled; });
    };

    isLoading.promise(projectState.load().then(function (project) {
        pageTitle(project.Name + " step templates");
        $scope.project = project;

        isLoading.promise(actionTemplateProcessor.getActionTemplates().then(function( templates ) {
            $scope.allTemplates = templates;
            $scope.filterTemplates();

            isLoading.promise(actionTemplateProcessor.getActionTemplatesAuthorizationAndFeatureConfig().then(function (results) {
                $scope.showActionTemplateTeaser = !results.isAuthorized;
                $scope.showLibraryTemplateTeaser = !results.configuration.IsCommunityActionTemplatesEnabled;
            }));
        }));
    }));
});






//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/step-templates/step_templates_controller.js
// module id = 570
// module chunks = 1